import React from 'react';
import { contentRoot } from '../config.js';
let fadein = { opacity: "1", transition: "opacity 1s ease-in-out" };
let fadeout = { opacity: "0", transition: "opacity 1s ease-in-out" };
let fade50p = { opacity: "0.5", transition: "opacity 1s ease-in-out" };
let fadeinDisplayNone = { opacity: "1", height: "0px", transition: "opacity 1s ease-in-out" };



let previousState = false;
let flip = { transform: "scaleX(-1)" };
const SaunaImageComponent = ({ loading, currentImage, previousImage,mirror }) => {
    let trasition = "";
    if (loading) {
        if (previousState === false) {
            trasition = "loadingStarted";
        }
        else {
            trasition = "loading";
        }
    }
    else {
        if (previousState === true) {
            trasition = "loadingFinished";
        }
        else {
            trasition = "inactive";
        }
    }
    let newImageStyle = {};
    switch (trasition) {
        case "loadingStarted":
            newImageStyle = fade50p;
            break;
        case "loadingFinished":
            newImageStyle = fadein;
            break;
        case "inactive":
            newImageStyle = fadein;
            break;
        case "loading":
            newImageStyle = fadein;
            break;
        default:
            break;
    }



    let loadingIconStyle = loading ? fade50p : fadeout;
    let oldImageStyle = (loading === false && previousState === true) ? fadeout : fadeinDisplayNone;
    if (mirror) {
        newImageStyle = Object.assign({ transform: "scaleX(-1)" }, newImageStyle);
        oldImageStyle = Object.assign({ transform: "scaleX(-1)" }, oldImageStyle);

    }
    previousState = loading;
    return (<div className="imagecontainer" id="imagecontainer">
        <img className="img-fluid"  src={currentImage} style={ newImageStyle} alt="sauna"></img>
        <img className="img-fluid layerImage" src={previousImage} style={oldImageStyle} alt="loading"></img>
        <img className="img-fluid layerImage" alt="loading" style={loadingIconStyle} src={contentRoot + "img/Loading_icon.gif"}></img>
    </div>
    )
};
export default SaunaImageComponent

